import React, { useEffect } from 'react';
import BalanceCardSlider from './Dashboard/BalanceCardSlider';
import Dashboard3 from './Dashboard3';
import MenuAccordion from './MenuAccordion';
import { useSelector } from 'react-redux';






const Home = () => {

	const getInvoiceByEmailData = useSelector(state => state.getInvoiceByEmail);

	useEffect(() => {
		if(getInvoiceByEmailData){
			// console.log("Home Invoice Data  : " + JSON.stringify(getInvoiceByEmailData));
		}
	}, []);

	return (
		<>
			<div className="row d-flex " style={{ gap: '10px', marginTop: '15px' }}>
				<Dashboard3 />
				{/* <MenuAccordion/> */}
				{/* <BalanceCardSlider /> */}

			</div>
		</>
	)
}
export default Home;